import { render, staticRenderFns } from "./registerComponent.vue?vue&type=template&id=166cdb0a&scoped=true"
import script from "./registerComponent.vue?vue&type=script&lang=js"
export * from "./registerComponent.vue?vue&type=script&lang=js"
import style0 from "./registerComponent.vue?vue&type=style&index=0&id=166cdb0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166cdb0a",
  null
  
)

export default component.exports